export const VIEW_BASIC_INFO_SUCCESS = 'VIEW_BASIC_INFO_SUCCESS';
export const UPDATE_ORDER_ROW_SUCCESS = 'UPDATE_ORDER_ROW_SUCCESS';
export const CREATE_ORDER_ROW_SUCCESS = 'CREATE_ORDER_ROW_SUCCESS';
export const EDIT_ORDER_ROW_SUCCESS = 'EDIT_ORDER_ROW_SUCCESS';
export const VIEW_EMAILS_SUCCESS = 'VIEW_EMAILS_SUCCESS';
export const NEW_EMAIL_SUCCESS = 'NEW_EMAIL_SUCCESS';
export const VIEW_SMS_SUCCESS = 'VIEW_SMS_SUCCESS';
export const NEW_SMS_SUCCESS = 'NEW_SMS_SUCCESS';
export const UPDATE_PREVENT_EMAILS_TO_BROKER_SUCCESS = 'UPDATE_PREVENT_EMAILS_TO_BROKER_SUCCESS';
export const UPDATE_PREVENT_EMAILS_TO_PHOTOGRAPHER_SUCCESS =
    'UPDATE_PREVENT_EMAILS_TO_PHOTOGRAPHER_SUCCESS';
export const UPDATE_PREVENT_COMMUNICATION_TO_PROPERTY_OWNER_SUCCESS = 'UPDATE_PREVENT_COMMUNICATION_TO_PROPERTY_OWNER_SUCCESS';
export const UNBOOK_PHOTOGRAPHER_SUCCESS = 'UNBOOK_PHOTOGRAPHER_SUCCESS';
export const PRECHECK_UNBOOK_PHOTOGRAPHER_SUCCESS = 'PRECHECK_UNBOOK_PHOTOGRAPHER_SUCCESS';
export const UNBOOK_STYLINGUSER_SUCCESS = 'UNBOOK_PHOTOGRAPHER_SUCCESS';
export const MARK_AS_UNREAD_ORDER_SUCCESS = 'MARK_AS_UNREAD_ORDER_SUCCESS';
export const UNARCHIVE_PHOTO_ORDER_SUCCESS = 'UNARCHIVE_PHOTO_ORDER_SUCCESS';
export const UNARCHIVE_PLAN_ORDER_SUCCESS = 'UNARCHIVE_PLAN_ORDER_SUCCESS';
export const UPDATE_OWNER_COMMUNICATION_LANGUAGE_SUCCESS =
    'UPDATE_OWNER_COMMUNICATION_LANGUAGE_SUCCESS';
export const UPDATE_IS_DIRECT_DELIVERY_SUCCESS = 'UPDATE_IS_DIRECT_DELIVERY_SUCCESS';
export const UPDATE_IMAGE_EDITOR_FIRM_SUCCESS = 'UPDATE_IMAGE_EDITOR_FIRM_SUCCESS';
export const UPDATE_IMAGE_EDITOR_SUCCESS = 'UPDATE_IMAGE_EDITOR_SUCCESS';
export const UPDATE_EXTRA_DELIVERY_RECIPIENTS_SUCCESS = 'UPDATE_EXTRA_DELIVERY_RECIPIENTS_SUCCESS';
export const SET_ORDER_TO_UPLOADER_SUCCESS = 'SET_ORDER_TO_UPLOADER_SUCCESS';
export const UPDATE_ORDER_STATE_SUCCESS = 'UPDATE_ORDER_STATE_SUCCESS';
export const LOCK_PHOTOGRAPHER_SUCCESS = 'LOCK_PHOTOGRAPHER_SUCCESS';
export const UNLOCK_PHOTOGRAPHER_SUCCESS = 'UNLOCK_PHOTOGRAPHER_SUCCESS';
export const DOWNLOAD_ATTACHED_FILE_SUCCESS = 'DOWNLOAD_ATTACHED_FILE_SUCCESS';
